import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Observable, Subject,  Subscription,  forkJoin, } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";


import { BOClinicHistory } from "../../models/BOClinicHistory.model";
import { BOFilter } from "../../models/BOFilter";
import { BOItem } from "../../models/BOItem.model";
import { ClinicHistoryService } from "../../services/clinicHistory.service";
import { ServiceTypeService } from '../../services/service-type.service';
import { ClinicHistoriesPatientComponent } from "../clinicHistoriesPatient.component";
import { InvoicesTaskComponent } from "../invoices-task/invoices-task.component";
import { InvoicesComponent } from "../invoices/invoices.component";
import { CreateOrEditOdontologyHistoryComponent } from "./createOrEditOdontologyHistory.component";
import { ServiceGroupsService } from "../../services/serviceGroups.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { BOPerson } from "../../models/BOPerson.model";
import { Utilities } from "../../common/utilities";

@Component({
    selector: 'app-odontology-history',
    templateUrl: './odontologyHistory.component.html',
    styleUrls: ['./odontologyHistory.component.css'],
    animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', overflow: 'hidden' })),
      state('expanded', style({ height: '*', overflow: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})
export class OdontologyHistoryComponent implements OnInit, OnDestroy {
    @ViewChild('createOrEditOdontologyHistoryModal')
    createOrEditOdontologyHistoryModal: CreateOrEditOdontologyHistoryComponent;

    @ViewChild('clinicHistoriesPatientModal') clinicHistoriesPatientModal: ClinicHistoriesPatientComponent;
    @ViewChild('invoicesModal') invoicesModal: InvoicesComponent;
    @ViewChild('invoicesTask') invoicesTask: InvoicesTaskComponent;
    // Properties
    clinicHistoryList: BOClinicHistory[] = [];
    clinicHistoryListShort: BOClinicHistory[] = [];
    clinicHistoryFilter: string = "";
    selectedArea: number = 0;

    selectedGroup:number=0;
    showCreateClinicHistory: boolean = false;
    showSearchPatient: boolean = false;
    serviceTypeList: BOItem[] = [];
    groupServiceList: BOItem[] = [];

    // Loading state
    loading$ = new BehaviorSubject<boolean>(false);
    filterRangesDates={
      startDate:null,
      endDate:null
    }
    areaSelected=3;
    // Destroy notifier
    private destroy$ = new Subject<void>();
    //busy:Subscription;
    spinnBusy=false;
    //new
    // dataSource: any[] = [{ name: '  Opciones de Historial' }];
     dataSource: any[] = [
    { name: 'OPCIONES PARA AUXILIAR', type: 'history' },
    { name: 'OPCIONES PARA MÉDICO', type: 'doctor' }
  ];
     displayedColumns = ['title', 'expand'];
     expandedElement: any | null;



    constructor(
        private toastr: ToastrService,
        private _clinicHistoryService: ClinicHistoryService,
        private _router: Router,
        private serviceTypeService: ServiceTypeService,
        private dialog: MatDialog,
        private _groupService: ServiceGroupsService
    ) {
      console.log('Entra a odontologyHistoryComponent');
    }

    ngOnInit(): void {

        this.loading$.next(true);
        this.spinnBusy = true; // Por si acaso lo usas en otro lado
        this.loadInitialData();
    }

    private loadInitialData(): void {
        //this.loading$.next(true);

        forkJoin({
            resultClinicHistory: this.getClinicHistoriesObservable(""),
            resultServiceTypeService: this.serviceTypeService.getAll(),
            resultGroupService: this._groupService.getAll(),
        })
        .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
              this.loading$.next(false);
              this.spinnBusy=false;
            })
        )
        .subscribe({
            next: ({ resultClinicHistory, resultServiceTypeService, resultGroupService }) => {
                this.serviceTypeList = resultServiceTypeService;
                    this.groupServiceList=resultGroupService.filter(x=>x.areaId==2),

                this.processClinicHistories(resultClinicHistory);
            },
            error: (error) => {
                this.loading$.next(false); // Asegurar que se apague en caso de error
                this.spinnBusy=false;
                console.error('Error loading initial data:', error);
                this.toastr.error('Error al cargar datos iniciales', 'Error');
            }
        });
    }

    getAllClinicHistories(optionToClose:string): void {
        this.loading$.next(true);
        const filter = this.clinicHistoryFilter.toUpperCase().trim();

        this.getClinicHistoriesObservable(filter)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.loading$.next(false))
            )
            .subscribe({
                next: (data: BOClinicHistory[]) => {  // Añadimos tipado explícito aquí
                    if (!data.length) {
                        this.clinicHistoryFilter = "";
                    }
                    this.processClinicHistories(data);
                    this.closeOpcionesAuxiliar(optionToClose);
                },
                error: (error) => {
                    console.error('Error fetching clinic histories:', error);
                    this.toastr.error('Error al obtener historias clínicas', 'Error');
                }
            });
    }

    navigateToClinicHistory(optionToClose:string): void {
    this.clinicHistoryFilter = "";
    this.getAllClinicHistories(optionToClose);
    }

    onAreaSelectionChange(event: MatSelectChange): void {
        this.selectedArea = event.value;
        this.filterClinicHistoriesByArea();
    }

   onGroupSelectionChange(event: MatSelectChange): void {
        this.selectedGroup = event.value;
        console.log('this.serviceGroupList is:',this.groupServiceList);
        this.filterClinicHistoriesByGroup();
  }


    // Private methods
    private getClinicHistoriesObservable(filter: string): Observable<BOClinicHistory[]> {
        const filterInput: BOFilter = { filter };
        return this._clinicHistoryService.getClinicHistories(filterInput,2);
    }

    private processClinicHistories(histories: BOClinicHistory[]): void {
        this.clinicHistoryList = histories;
        console.log('Al entrar a processclinicHistoryList es:', this.clinicHistoryList);

        if (this.clinicHistoryList.length > 0)
        {
            // Assign service type names
            this.clinicHistoryList.forEach(history => {
                history.serviceTypeName = this.serviceTypeList.find(x =>
                    x.code === history.serviceType)?.name;
            });

            this.filterClinicHistoriesByArea();

        } else {
            this.clinicHistoryListShort = [];
            this.toastr.error('Sin datos', 'No hay historias clínicas');
        }
    }


    private filterClinicHistoriesByArea(): void {
        if (this.selectedArea === 3 || this.selectedArea === 0) {
            // Show all records
            this.clinicHistoryListShort = [...this.clinicHistoryList];
        } else {
            // Filter by selected area
            this.clinicHistoryListShort = this.clinicHistoryList
                .filter(x => x.area === this.selectedArea);
        }
    }

    private filterClinicHistoriesByGroup(): void {
      let selectedGroupString="";

      if(this.selectedGroup<10)
      {
        selectedGroupString="0"+this.selectedGroup.toString().trim();
      }
      else
      {
        selectedGroupString=this.selectedGroup.toString().trim();

      }
      console.log( 'this.clinicHistoryListShort is:', this.clinicHistoryListShort);
      this.clinicHistoryListShort = this.clinicHistoryList
                .filter(x => x.serviceGroups == selectedGroupString);


              console.log("En filterCh, this.clinicHistoryListShort es:", this.clinicHistoryListShort);
        if(this.clinicHistoryListShort.length<=0)
        {
          this.toastr.warning("Sin data", "No hay registros",{
          timeOut: 1500} );
        }
    }


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    openToSeeInvoice(clinicHistoryId:number)
    {

      return new Promise<void>((resolve, reject) => {
        try {
          // Ejecutar el método openModal
          this.createOrEditOdontologyHistoryModal.openModal(clinicHistoryId, false, 'edi');

          // Asegurarse de resolver después de que el openModal termine
          resolve();
        } catch (error) {
          // Si ocurre algún error, rechaza la promesa
          reject(error);
        }
      }).then(() => {
        // Llamar al método openCreateReport después de que openModal haya finalizado
        this.createOrEditOdontologyHistoryModal.openCreateReport(clinicHistoryId);
      }).catch((error) => {
        console.error('Error al ejecutar las acciones:', error);
      });
    }

    navigateToOdontogramaFromOdontologyHistory(clinicHistoryId:number, patientId:number)
    {
      console.log("Entra a navigatToOdontogramaFromOdontologyHistory");
            console.log("En ntofoh, clinicHistoryId es:",clinicHistoryId,
        " patientId es:", patientId );


      this._router.navigate(['/dental-Admins/odontograma'], {

        queryParams: {
          clinicHistory: clinicHistoryId,
          personId: patientId,
         // odontogramaId:odontogramaId
        }
      });
    }

    onSvgClick(event: Event, odontogramaId:number) {
  if (odontogramaId == 0) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  // Tu lógica normal del click aquí
  console.log('SVG clicked');
}

getClinicalHistoriesByAllAndDates()
{

    this._clinicHistoryService.getCHWithPatientByDatesAndArea(this.filterRangesDates, 2)
        .subscribe({
          next:(data:BOClinicHistory[])=>{
            this.clinicHistoryListShort=[];

            if(data.length>0)
            {
              this.clinicHistoryList=data;

              this.clinicHistoryListShort=data;
              this.selectedGroup=0;


                          // Assign service type names
              this.clinicHistoryListShort.forEach(history => {
                  history.serviceTypeName = this.serviceTypeList.find(x =>
                      x.code === history.serviceType)?.name;
              });

              console.log('data en getPatientByDatesAndArea:', data);
            }
            else{
              this.toastr.warning("Sin data", "No hay registros", {
              timeOut: 1500 });
            }
          },
          error:(err)=>{
                    console.log("Error al obtener Historias Clínicas");
          },
          complete:()=>{
            console.log("Servicio completado");
          }

        });//end subscribe
}

 toggleExpansion(element: any): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

closeOpcionesAuxiliar(optionChoosed:string): void {
    //const elementToClose = this.dataSource.find(el => el.name === 'OPCIONES PARA AUXILIAR');
    const elementToClose = this.dataSource.find(el => el.name === optionChoosed);

    if (elementToClose && this.expandedElement === elementToClose) {
      this.toggleExpansion(elementToClose);  // Esto la colapsará (expandedElement = null)
    }
  }

handleCallgetName(person: BOPerson):string
{
  const name= Utilities.getNameFromPerson(person);
  return name;
}

 openEvolutions(clinicHistoryId:number)
 {
    return new Promise<void>((resolve, reject) => {
            try {
              // Ejecutar el método openModal
              this.createOrEditOdontologyHistoryModal.openModal(clinicHistoryId, false, 'edi');
              // Asegurarse de resolver después de que el openModal termine
              resolve();
            } catch (error) {
              // Si ocurre algún error, rechaza la promesa
              reject(error);
            }
          }).then(() => {
            // Ir a la pantalla Diagnosticos
            this.createOrEditOdontologyHistoryModal.goToEvolutions(clinicHistoryId);
          }).catch((error) => {
            console.error('Error al ejecutar las acciones:', error);
          });
 }



}
